import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useWorkspaceSwitching } from "src/context/WorkspaceSwitchingContext";
import TravelHeader from "src/components/travel/shared/TravelHeader";

const TravelLayout = () => {
  const { finishSwitching } = useWorkspaceSwitching();

  useEffect(() => {
    finishSwitching();
  }, [finishSwitching]);

  return (
    <div className="min-h-screen bg-[#2D0B31] font-lato flex font-normal">
      <div className="flex-shrink flex-grow flex flex-col transition-all duration-300">
        <TravelHeader />
        <div className="relative flex-shrink flex-grow w-full transition-all duration-300 flex">
          <div className="relative overflow-hidden w-full bg-[#fafbfe] shadow-[-2px_-2px_10px_rgba(0,0,0,0.2)]">
            <div className="max-h-[calc(100dvh-4rem)] overflow-auto">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravelLayout;
